import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const MarketingLayout = lazy(() => import('./pages/marketing/MarketingLayout'));
const NdsLandingPage = lazy(() => import('./pages/marketing/NdsLandingPage'));
const DataVaultPage = lazy(() => import('./pages/marketing/services/DataVaultPage'));
const ExocompsPage = lazy(() => import('./pages/marketing/services/ExocompsPage'));
const ManagedITPage = lazy(() => import('./pages/marketing/services/ManagedITPage'));
const PracticeIntegrationPage = lazy(() => import('./pages/marketing/services/PracticeIntegrationPage'));
const Cms0057fPage = lazy(() => import('./pages/marketing/services/Cms0057fPage'));
const BlogPage = lazy(() => import('./pages/marketing/BlogPage'));
const BlogPostPage = lazy(() => import('./pages/marketing/BlogPostPage'));
const AboutPage = lazy(() => import('./pages/marketing/AboutPage'));

// Category pages
const DentalDataWarehousePage = lazy(() => import('./pages/marketing/categories/DentalDataWarehousePage'));
const DentalPMSIntegrationPage = lazy(() => import('./pages/marketing/categories/DentalPMSIntegrationPage'));
const DentalAnalyticsPlatformPage = lazy(() => import('./pages/marketing/categories/DentalAnalyticsPlatformPage'));
const DSODataPlatformPage = lazy(() => import('./pages/marketing/categories/DSODataPlatformPage'));

// Comparison pages
const NDSVsKollaPage = lazy(() => import('./pages/marketing/compare/NDSVsKollaPage'));
const NDSVsDentalBridgePage = lazy(() => import('./pages/marketing/compare/NDSVsDentalBridgePage'));
const NDSVsDentalIntelligencePage = lazy(() => import('./pages/marketing/compare/NDSVsDentalIntelligencePage'));
const NDSVsJarvisPage = lazy(() => import('./pages/marketing/compare/NDSVsJarvisPage'));

// Guide pages
const DentalDataWarehouseGuidePage = lazy(() => import('./pages/marketing/guides/DentalDataWarehouseGuidePage'));
const DentalPMSExtractionPage = lazy(() => import('./pages/marketing/guides/DentalPMSExtractionPage'));
const DSOKPIModelPage = lazy(() => import('./pages/marketing/guides/DSOKPIModelPage'));
const DentalDataGovernancePage = lazy(() => import('./pages/marketing/guides/DentalDataGovernancePage'));

// Stack + best-of + market map
const StackPage = lazy(() => import('./pages/marketing/StackPage'));
const BestDentalDataWarehousePage = lazy(() => import('./pages/marketing/BestDentalDataWarehousePage'));
const DSOMarketMapPage = lazy(() => import('./pages/marketing/DSOMarketMapPage'));

function Loading() {
  return <div style={{ textAlign: 'center', padding: '4rem', color: '#888' }}>Loading...</div>;
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<NdsLandingPage />} />
              <Route path="/nds" element={<NdsLandingPage />} />
              <Route path="/nds/datavault" element={<DataVaultPage />} />
              <Route path="/nds/exocomps" element={<ExocompsPage />} />
              <Route path="/nds/managed-it" element={<ManagedITPage />} />
              <Route path="/nds/practice-integration" element={<PracticeIntegrationPage />} />
              <Route path="/nds/cms-0057-f" element={<Cms0057fPage />} />
              <Route path="/nds/blog" element={<BlogPage />} />
              <Route path="/nds/blog/:id" element={<BlogPostPage />} />
              <Route path="/nds/about" element={<AboutPage />} />

              {/* Category pages */}
              <Route path="/nds/dental-data-warehouse" element={<DentalDataWarehousePage />} />
              <Route path="/nds/dental-pms-integration" element={<DentalPMSIntegrationPage />} />
              <Route path="/nds/dental-analytics-platform" element={<DentalAnalyticsPlatformPage />} />
              <Route path="/nds/dso-data-platform" element={<DSODataPlatformPage />} />

              {/* Comparison pages */}
              <Route path="/nds/compare/nds-vs-kolla" element={<NDSVsKollaPage />} />
              <Route path="/nds/compare/nds-vs-dentalbridge" element={<NDSVsDentalBridgePage />} />
              <Route path="/nds/compare/nds-vs-dental-intelligence" element={<NDSVsDentalIntelligencePage />} />
              <Route path="/nds/compare/nds-vs-jarvis" element={<NDSVsJarvisPage />} />

              {/* Guide pages */}
              <Route path="/nds/dental-data-warehouse-guide" element={<DentalDataWarehouseGuidePage />} />
              <Route path="/nds/dental-pms-data-extraction" element={<DentalPMSExtractionPage />} />
              <Route path="/nds/dso-kpi-data-model" element={<DSOKPIModelPage />} />
              <Route path="/nds/dental-data-governance" element={<DentalDataGovernancePage />} />

              {/* Stack + best-of + market map */}
              <Route path="/nds/stack" element={<StackPage />} />
              <Route path="/nds/best-dental-data-warehouse" element={<BestDentalDataWarehousePage />} />
              <Route path="/nds/dental-dso-market-map" element={<DSOMarketMapPage />} />

              {/* Convenience routes without /nds prefix */}
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/datavault" element={<DataVaultPage />} />
              <Route path="/exocomps" element={<ExocompsPage />} />
              <Route path="/managed-it" element={<ManagedITPage />} />
              <Route path="/practice-integration" element={<PracticeIntegrationPage />} />
              <Route path="/cms-0057-f" element={<Cms0057fPage />} />
              <Route path="/dental-data-warehouse" element={<DentalDataWarehousePage />} />
              <Route path="/dental-pms-integration" element={<DentalPMSIntegrationPage />} />
              <Route path="/dental-analytics-platform" element={<DentalAnalyticsPlatformPage />} />
              <Route path="/stack" element={<StackPage />} />
              <Route path="/best-dental-data-warehouse" element={<BestDentalDataWarehousePage />} />
              <Route path="/dental-dso-market-map" element={<DSOMarketMapPage />} />
              <Route path="/dental-data-warehouse-guide" element={<DentalDataWarehouseGuidePage />} />
              <Route path="/dental-pms-data-extraction" element={<DentalPMSExtractionPage />} />
              <Route path="/dso-kpi-data-model" element={<DSOKPIModelPage />} />
              <Route path="/dental-data-governance" element={<DentalDataGovernancePage />} />
            </Route>
            {/* Catch-all → homepage */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}
